import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded'

const ArrivalProximityDialog = ({
  open,
  check,
  actorLabel = 'This resource',
  onCancel,
  onConfirm,
  confirming = false,
}) => {
  const targetLabel = check?.targetLabel || 'location'
  const title = check?.unableToVerify
    ? 'Location not verified'
    : `Not near ${targetLabel}`
  const message = check?.unableToVerify
    ? `${actorLabel} location could not be verified against the ${targetLabel}.`
    : `${actorLabel} ${actorLabel === 'You' ? 'appear' : 'appears'} to be ${check?.distanceLabel} from the ${targetLabel}.`

  return (
    <Dialog open={open} onClose={confirming ? undefined : onCancel} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <WarningAmberRounded color="contrast" />
          <Typography sx={{ fontWeight: 900 }}>{title}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: 'text.secondary' }}>
          {message} Are you sure you want to mark this journey as arrived?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} color="inherit" disabled={confirming}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="contrast"
          disabled={confirming}
        >
          {confirming ? 'Updating...' : 'Mark arrived'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ArrivalProximityDialog
